import { render, staticRenderFns } from "./metadata-general.vue?vue&type=template&id=39eef00d&scoped=true&"
import script from "./metadata-general.vue?vue&type=script&lang=js&"
export * from "./metadata-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eef00d",
  null
  
)

export default component.exports